"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sBarReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var SbarAction_1 = require("@/pages/search/actions/sfilter/SbarAction");
var SfilterKeywordAction_1 = require("@/pages/search/actions/sfilter/SfilterKeywordAction");
var SbarState_init_1 = require("@/pages/search/states/SbarState.init");
exports.sBarReducer = function (state, action) {
    if (state === void 0) { state = SbarState_init_1.defaultSbarState; }
    switch (action.type) {
        case typesafe_actions_1.getType(SfilterKeywordAction_1.default.changeFilterKeyword): {
            return __assign(__assign({}, state), { textbox: action.payload });
        }
        case typesafe_actions_1.getType(SbarAction_1.default.setText): {
            return __assign(__assign({}, state), { textbox: action.payload });
        }
    }
    return state;
};
